import { useEffect } from "react";
import {
  getSurplusBeforeTaxYear3,
  getTemplatePayrollTaxYear3,
  getFixedEarnedIncomeYear3,
  getTaxableIncomeYear3,
  getLocalTaxesYear3,
  getStateTaxYear3,
  getPayrollTaxYear3,
  getGeneralPensionYear3,
  getFuneralFeesYear3,
  getReductionOfGeneralPensionYear3,
  getEarnedIncomeTaxYear3,
  getNetProfitPerYearYear3,
  getNetProfitPerMonthYear3,
  getGeneralPayrollTaxYear3,
  getGrossAnnualSalaryYear3,
} from "../Redux/Actions/salarycalculationYear3";

export const CalculationYear3 = (
  dispatch,
  calculating,
  templatePayrollPercent,
  standardTaxRelief,
  localTaxesPercent,
  payrollTaxPercent,
  generalPensionPercent,
  generalPensionCutOffValue,
  funeralFeesPercent,
  earnedIncomeTaxCutOffValue,
  earnedIncomeTaxPercent,
  generalPayrollTaxPercent,
  activeCompany,
  activeYear,
  totalFixedCost,
  totalYearGrossMargin,
  totalMeasuredCostsPerYear,
  nonTaxableIncomeLimit,
  stateTaxCutOfValue,
  stateTaxPercent,
  totalYearGrossMarginPerYear,
  totalFixedCostPerYear,
  salaryCalculationData,
  setCalculating
) => {
  //set companyform for measuresDashboard
  let companyFormYear3 = "";

  salaryCalculationData?.map(
    (item) => (companyFormYear3 = item.object.activeCompany.companyFormYear3)
  );

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      function calculationsYear3() {
        const resultSurplus =
          totalYearGrossMarginPerYear.year3 -
          totalFixedCostPerYear.year3 -
          totalMeasuredCostsPerYear.year3;
        if (resultSurplus === 0) {
          dispatch(getSurplusBeforeTaxYear3(0));
        } else {
          resultSurplus && dispatch(getSurplusBeforeTaxYear3(resultSurplus));
        }

        //get template payroll tax (egenavgifter schablon)
        let resultTemplatePayrollTax =
          (templatePayrollPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultTemplatePayrollTax = 0;
          dispatch(getTemplatePayrollTaxYear3(0));
        } else {
          resultTemplatePayrollTax &&
            dispatch(getTemplatePayrollTaxYear3(resultTemplatePayrollTax));
        }
        //#region CompanyForm in "Aktiebolag"
        //get General payroll tax (arbetsgivaravgift)
        let resultGeneralPayrollTax =
          (generalPayrollTaxPercent / 100) * resultSurplus;
        if (resultSurplus <= 0) {
          resultGeneralPayrollTax = 0;
          dispatch(getGeneralPayrollTaxYear3(0));
        } else {
          resultGeneralPayrollTax &&
            dispatch(getGeneralPayrollTaxYear3(resultGeneralPayrollTax));
        }

        //get gross year salary (Årslön brutto)
        let resultGrossAnnualSalary = resultSurplus - resultGeneralPayrollTax;
        if (resultSurplus <= 0) {
          resultGrossAnnualSalary = 0;
          dispatch(getGrossAnnualSalaryYear3(0));
        } else {
          resultGrossAnnualSalary &&
            dispatch(getGrossAnnualSalaryYear3(resultGrossAnnualSalary));
        }

        //get taxBase ("skatteunderlag" (Anders excel)
        let taxBase = resultGrossAnnualSalary + standardTaxRelief;
        if (resultGrossAnnualSalary <= nonTaxableIncomeLimit) {
          taxBase = 0;
        }
        //#endregion CompanyForm in "Aktiebolag"

        //get fixed earned income (fastställd förvärvsinkomst)
        let resultFixedEarnedIncome = resultSurplus - resultTemplatePayrollTax;
        if (resultSurplus <= 0) {
          resultFixedEarnedIncome = 0;
          dispatch(getFixedEarnedIncomeYear3(0));
        } else {
          resultFixedEarnedIncome &&
            dispatch(getFixedEarnedIncomeYear3(resultFixedEarnedIncome));
        }

        //get taxable income (beskattningsbar inkomst)
        let resultTaxableIncome = resultFixedEarnedIncome + standardTaxRelief;
        if (companyFormYear3 === "aktiebolag") {
          resultTaxableIncome = taxBase;
        }
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn. Cut off point salarycalculation stops. else standardtaxRelief is drawn
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultTaxableIncome = 0;
          dispatch(getTaxableIncomeYear3(0));
        } else {
          resultTaxableIncome &&
            dispatch(getTaxableIncomeYear3(resultTaxableIncome));
        }

        //get local taxes (kommunalskatt)
        let resultLocalTaxes = (localTaxesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultLocalTaxes = 0;
          dispatch(getLocalTaxesYear3(0));
        } else {
          resultLocalTaxes && dispatch(getLocalTaxesYear3(resultLocalTaxes));
        }

        //get state tax (statlig skatt)
        let resultStateTax =
          (stateTaxPercent / 100) * (resultTaxableIncome - stateTaxCutOfValue);
        //if resultStateTax is less than the cut off value no state tax will be drawn.
        if (resultStateTax <= 0) {
          resultStateTax = 0;
          dispatch(getStateTaxYear3(0));
        } else {
          resultStateTax && dispatch(getStateTaxYear3(resultStateTax));
        }
        //egenavgifter
        let resultPayrollTax =
          (payrollTaxPercent / 100) * resultFixedEarnedIncome;
        if (resultPayrollTax === 0) {
          dispatch(getPayrollTaxYear3(0));
        } else {
          resultPayrollTax && dispatch(getPayrollTaxYear3(resultPayrollTax));
        }

        //get general pension (allmän pension)
        let resultGeneralPension =
          (generalPensionPercent / 100) * resultTaxableIncome;
        //if resultGeneralPension is more than the max cut off value max cut off value will be drawn.
        if (resultGeneralPension > generalPensionCutOffValue) {
          resultGeneralPension &&
            dispatch(getGeneralPensionYear3(generalPensionCutOffValue));
          resultGeneralPension = generalPensionCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultGeneralPension = 0;
          dispatch(getGeneralPensionYear3(0));
        }
        //if resultGeneralPension is between cut off value and nonTaxable limit, pension will be drawn.
        else {
          resultGeneralPension &&
            dispatch(getGeneralPensionYear3(resultGeneralPension));
        }
        //get funeral fees (kyrko och begravningsavgift)
        let resultFuneralFees =
          (funeralFeesPercent / 100) * resultTaxableIncome;
        //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultFuneralFees = 0;
          dispatch(getFuneralFeesYear3(0));
        } else {
          resultFuneralFees && dispatch(getFuneralFeesYear3(resultFuneralFees));
        }
        //get reduction of general pension(skattereduktion för allmän pension)
        //resultReductionOfGeneralPension mirrors resultGeneralPension and same amount drawn will be returned
        let resultReductionOfGeneralPension = resultGeneralPension;
        if (resultReductionOfGeneralPension > generalPensionCutOffValue) {
          resultReductionOfGeneralPension &&
            dispatch(
              getReductionOfGeneralPensionYear3(generalPensionCutOffValue)
            );
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn or returned.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultReductionOfGeneralPension = 0;
          dispatch(getReductionOfGeneralPensionYear3(0));
        } else {
          resultReductionOfGeneralPension &&
            dispatch(
              getReductionOfGeneralPensionYear3(resultReductionOfGeneralPension)
            );
        }
        //get earned income (jobbskatteavdrag)
        let resultEarnedIncomeTax =
          (earnedIncomeTaxPercent / 100) * resultTaxableIncome;
        //if resultEarnedIncomeTax is more than max cut off value, max cut off value will be returned
        if (resultEarnedIncomeTax > earnedIncomeTaxCutOffValue) {
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTaxYear3(earnedIncomeTaxCutOffValue));
          resultEarnedIncomeTax = earnedIncomeTaxCutOffValue;
          //if resultfixedIncome is less than the non taxable limit of 20135kr (2021) no tax can be drawn.
        } else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
          resultEarnedIncomeTax = 0;
          dispatch(getEarnedIncomeTaxYear3(0));
        } else {
          //if resultEarnedIncome is less than max cut of value but more than non taxable limit earnedIncometax will be returned.
          resultEarnedIncomeTax &&
            dispatch(getEarnedIncomeTaxYear3(resultEarnedIncomeTax));
        }

        if (companyFormYear3 === "enskildFirma") {
          let resultNetProfitPerYear =
            resultSurplus -
            resultLocalTaxes -
            resultStateTax -
            resultPayrollTax -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYearYear3(0));
          }
          // if resultFixedEarnedIncome is less than the nontaxable limit no tax will be drawn but resultpayrolltax is always drawn
          else if (resultFixedEarnedIncome <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultFixedEarnedIncome - resultPayrollTax;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear3(resultNetProfitPerYear));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear3(resultNetProfitPerYear));
          }

          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonthYear3(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonthYear3(resultNetProfitPerMonth));
          }
        } else if (companyFormYear3 === "aktiebolag") {
          let resultNetProfitPerYear =
            taxBase -
            resultLocalTaxes -
            resultGeneralPension -
            resultFuneralFees +
            resultReductionOfGeneralPension +
            resultEarnedIncomeTax -
            resultStateTax;
          if (resultNetProfitPerYear === 0) {
            dispatch(getNetProfitPerYearYear3(0));
          } else if (taxBase <= nonTaxableIncomeLimit) {
            resultNetProfitPerYear = resultGrossAnnualSalary;
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear3(resultGrossAnnualSalary));
          } else {
            resultNetProfitPerYear &&
              dispatch(getNetProfitPerYearYear3(resultNetProfitPerYear));
          }
          //get net profit per month(månadslön netto)
          const resultNetProfitPerMonth = resultNetProfitPerYear / 12;
          if (resultNetProfitPerMonth === 0) {
            dispatch(getNetProfitPerMonthYear3(0));
          } else {
            resultNetProfitPerMonth &&
              dispatch(getNetProfitPerMonthYear3(resultNetProfitPerMonth));
          }
        }
      }
      calculationsYear3();
      //give time for calculations() to calculate usong calculating hook
      const delay = setTimeout(() => {
        setCalculating(true);
      }, 700);
      return () => clearTimeout(delay);
    }
    return () => {
      isMounted = false;
    };
  }, [
    dispatch,
    calculating,
    templatePayrollPercent,
    standardTaxRelief,
    localTaxesPercent,
    payrollTaxPercent,
    generalPensionPercent,
    generalPensionCutOffValue,
    funeralFeesPercent,
    earnedIncomeTaxCutOffValue,
    earnedIncomeTaxPercent,
    generalPayrollTaxPercent,
    activeCompany,
    activeYear.year,
    totalFixedCost,
    totalYearGrossMargin,
    totalMeasuredCostsPerYear,
    nonTaxableIncomeLimit,
    stateTaxCutOfValue,
    stateTaxPercent,
    totalYearGrossMarginPerYear.year3,
    totalFixedCostPerYear.year3,
    salaryCalculationData,
    companyFormYear3,
    setCalculating,
  ]);
};
